import React, {Fragment} from 'react';

import conciergeImg from 'presentation/assets/images/campanario-concierge-no-balcao-de-check.webp';
import {ConciergeDrawer} from 'presentation/components/ConciergeDrawer';
import {useConciergeBenefits} from 'presentation/pages/private/hooks/useConciergeBenefits';
import {translations} from 'presentation/translations-new';
import {PerksCard} from '../PerksCard';

const {
	concierge: {title, description},
} = translations['pt-br'].privateFlow.perks;
const {seeMore} = translations['pt-br'].commons;

export function Concierge() {
	const {onOpenConciergeDrawer, isLoading} = useConciergeBenefits();

	return (
		<Fragment>
			<PerksCard
				cardImage={conciergeImg}
				description={description}
				title={title}
				handleAction={onOpenConciergeDrawer}
				isLoading={isLoading}
				buttonIcon="arrow-right"
				buttonText={seeMore}
			/>
			<ConciergeDrawer />
		</Fragment>
	);
}
